import { Box, ColorOptions, convertHexToRGBA, IconNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { Colors } from '../../util/util'
import { CircularProgress } from './CircularProgress'

export const CircleProgressAnimation = ({ onClick, autoDismiss, autoCloseInSecs = 11 }: any) => {
  const [time, setTimeLeft] = useState(0)
  useEffect(() => {
    let timer
    if (time <= autoCloseInSecs - 1) {
      timer = () => {
        setTimeLeft(time + 1)
      }
      setTimeout(timer, 1000)
    } else if (time === autoCloseInSecs && autoDismiss && onClick) {
      console.log('auto dismiss', autoDismiss, time, autoCloseInSecs)
      onClick?.()
    }
    return clearTimeout(timer)
  }, [time, onClick, autoDismiss, autoCloseInSecs])

  return (
    <Box
      underlayColor={'TRANSPARENT'}
      position="absolute"
      alignItems="center"
      justifyContent={'center'}
      testID="close-cirle"
      onPress={onClick}>
      <CircularProgress
        startTimer={autoDismiss}
        radius={26}
        percentage={time}
        max={autoCloseInSecs - 1}
        strokeWidth={2}
        color={Colors.PRIMARY}>
        <Box
          position={'absolute'}
          left={3}
          top={3}
          bg={convertHexToRGBA(Colors.PRIMARY, 20) as ColorOptions}
          width={46}
          height={46}
          borderRadius={46}
          align="center"
          justify="center">
          <IconNew id="ICON_CLOSE" size={20} color="PRIMARY" />
        </Box>
      </CircularProgress>
    </Box>
  )
}
